export enum Colors {
  // some basics
  WHITE = "#FFFFFF",
  BLACK = "#000000",

  // green
  GREEN = "#00940F",

  // red
  RED = "#940000",

  // purple
  PURPLE = "#B02677",
  LIGHT_PURPLE = "#EC49A8",

  // gray
  DARK_GRAY = "#8F8F8F",
  MID_GRAY = "#B1B1B1",
  MIGHT_MID_GRAY = "#CFCFCF",
  LIGHT_GRAY = "#F2F2F2",
  TEXT_GRAY = "#333",

  // blue
  BLUE = "#1D498A",
  MID_BLUE = "#85b6ff",
  LIGHT_BLUE = "#CDE2FF",
  VERY_LIGHT_BLUE = "#EEF5FF",
}
